export const channelConstants = {
  CHANNEL_REDUCER_REQUEST: 'CHANNEL_REDUCER_REQUEST',
  CHANNEL_REDUCER_SUCCESS: 'CHANNEL_REDUCER_SUCCESS',
  CHANNEL_REDUCER_FAILURE: 'CHANNEL_REDUCER_FAILURE',

  CHANNEL_INTEGRATION_REQUEST: 'CHANNEL_INTEGRATION_REQUEST',
  CHANNEL_INTEGRATION_SUCCESS: 'CHANNEL_INTEGRATION_SUCCESS',
  CHANNEL_INTEGRATION_FAILURE: 'CHANNEL_INTEGRATION_FAILURE',
  
  UPDATE_INTEGRATION_REQUEST: 'UPDATE_INTEGRATION_REQUEST',
  UPDATE_INTEGRATION_SUCCESS: 'UPDATE_INTEGRATION_SUCCESS',
  UPDATE_INTEGRATION_FAILURE: 'UPDATE_INTEGRATION_FAILURE'
}